import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';
import { UserId } from '@/portainer/users/types';
import { buildUrl } from '@/portainer/users/buildUrl';
import { userQueryKeys } from '@/portainer/users/queries/queryKeys';

export function useDeleteUserMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: UserId) => deleteUser(id),
    ...withError('Unable to delete user'),
    onSuccess(_, id) {
      queryClient.removeQueries(userQueryKeys.user(id));
      queryClient.removeQueries(userQueryKeys.memberships(id));
      return queryClient.invalidateQueries(userQueryKeys.base());
    },
  });
}

export async function deleteUser(id: UserId) {
  try {
    await axios.delete(buildUrl(id));
  } catch (error) {
    throw parseAxiosError(error);
  }
}
